import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../context/AuthContext";
import { toast } from "sonner";
import { Users, Wallet, Lock, Trophy } from "lucide-react";

export default function FantaTeam({ rallyId, requireLogin, onDone, user }) {
  const [info, setInfo] = useState(null);
  const [team, setTeam] = useState(null);
  const [sel, setSel] = useState([]);
  const [name, setName] = useState("");
  const [q, setQ] = useState("");
  const [lb, setLb] = useState([]);
  const [busy, setBusy] = useState(false);
  const [swapOut, setSwapOut] = useState(null);
  const swap = async (inEntry) => {
    if (!swapOut) return;
    setBusy(true);
    try { const { data } = await axios.post(`${API}/paddock/rallies/${rallyId}/fanta/swap`, { out_id: swapOut, in_id: inEntry.id }); toast.success(`Cambio effettuato (-${data.penalty} crediti)`); setSwapOut(null); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Cambio non riuscito"); } finally { setBusy(false); }
  };

  const load = async () => {
    const { data } = await axios.get(`${API}/paddock/rallies/${rallyId}/fanta`); setInfo(data);
    axios.get(`${API}/paddock/rallies/${rallyId}/fanta/leaderboard`).then(r => setLb(r.data)).catch(() => {});
    if (user) axios.get(`${API}/paddock/rallies/${rallyId}/fanta/me`).then(r => { if (r.data) { setTeam(r.data); setSel(r.data.entry_ids); setName(r.data.name); } }).catch(() => {});
  };
  useEffect(() => { load(); }, [rallyId, user]);
  if (!info) return <div className="text-center text-slate-500 py-10">Caricamento…</div>;

  const cost = sel.reduce((s, id) => s + (info.entries.find(e => e.id === id)?.cost || 0), 0);
  const left = info.budget - cost;
  const toggle = (e) => {
    if (info.locked) return;
    if (sel.includes(e.id)) return setSel(sel.filter(x => x !== e.id));
    if (sel.length >= info.team_size) return toast.info(`Massimo ${info.team_size} equipaggi`);
    if (e.cost > left) return toast.error("Budget insufficiente");
    setSel([...sel, e.id]);
  };
  const save = async () => {
    if (!requireLogin()) return;
    setBusy(true);
    try { const { data } = await axios.post(`${API}/paddock/rallies/${rallyId}/fanta`, { entry_ids: sel, name }); setTeam(data); toast.success(team ? "Squadra aggiornata" : "Squadra creata! +50 punti"); load(); onDone(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };
  const list = info.entries.filter(e => `${e.number} ${e.driver} ${e.car} ${e.class_name}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="fanta-team">
      <div className="rl-banner rl-watermark p-6 mb-5 flex flex-wrap items-center justify-between gap-4">
        <div className="relative">
          <div className="pill-badge pill-amber mb-2"><Users className="w-3 h-3" /> SQUADRA FANTA</div>
          <div className="font-display font-black text-2xl">Componi la tua squadra di {info.team_size} equipaggi.</div>
          <div className="text-sm text-slate-400">Budget {info.budget} crediti · ogni PS i tuoi equipaggi guadagnano punti in base alla posizione (1° 25 pt, 2° 18, 3° 15…). {info.locked ? "Squadre bloccate: gara in corso." : "Le squadre si bloccano alla prima PS."}</div>
        </div>
        <div className="relative rl-card px-5 py-3 flex items-center gap-4">
          <Wallet className="w-6 h-6 text-[#FF9F0A]" />
          <div><div className="text-[10px] font-mono-rl text-slate-400 tracking-widest">CREDITI RESIDUI</div>
            <div className={`font-display font-black text-3xl ${left < 0 ? "text-[#FF1E27]" : ""}`} data-testid="fanta-budget-left">{left}</div></div>
        </div>
      </div>

      <div className="grid lg:grid-cols-3 gap-5">
        <div className="lg:col-span-2 rl-card p-5">
          <div className="grid grid-cols-3 gap-2 mb-4">
            {[0, 1, 2].map(i => { const e = info.entries.find(x => x.id === sel[i]); return (
              <button key={i} onClick={() => info.locked ? (team && e && setSwapOut(swapOut === e.id ? null : e.id)) : (e && toggle(e))} data-testid={`fanta-slot-${i + 1}`}
                className={`border rounded-lg p-3 text-left min-h-[70px] ${swapOut === e?.id ? "border-[#FF1E27] bg-[#FF1E27]/10" : e ? "border-[#FF9F0A]/60 bg-[#FF9F0A]/10" : "border-dashed border-white/15"}`}>
                {e ? <><div className="font-mono-rl text-[#FF1E27] text-xs">#{e.number} · {e.cost} cr</div><div className="text-sm font-semibold truncate">{e.driver}</div><div className="text-[10px] text-slate-500 truncate">{e.car}</div></> : <div className="text-xs text-slate-500">Slot {i + 1}</div>}
              </button>); })}
          </div>
          {!info.locked && (
            <>
              <div className="flex gap-2 mb-3">
                <input className="flex-1 bg-black/40 border border-white/10 rounded-md px-3 py-2 text-sm outline-none focus:border-[#FF1E27]" placeholder="Nome squadra" value={name} onChange={e => setName(e.target.value)} data-testid="fanta-team-name" />
                <button className="btn-crimson !py-2 text-sm" disabled={sel.length !== info.team_size || left < 0 || busy} onClick={save} data-testid="fanta-save-btn">{team ? "AGGIORNA" : "CONFERMA SQUADRA"}</button>
              </div>
              <input className="w-full bg-black/40 border border-white/10 rounded-md px-3 py-2 text-sm outline-none focus:border-[#FF1E27] mb-2" placeholder="Cerca pilota, numero, classe…" value={q} onChange={e => setQ(e.target.value)} data-testid="fanta-search" />
            </>
          )}
          {info.locked && (
            <div className="mb-3">
              <div className="text-xs font-mono-rl text-slate-400 flex items-center gap-1"><Lock className="w-3 h-3" /> MERCATO TRA PS {team ? `· ${team.name}: ${team.points} pt` : ""}</div>
              {team && <div className="text-[11px] text-slate-500 mt-1">Tra una tappa e l'altra puoi sostituire 1 equipaggio per PS disputata (usati {team.swaps_used || 0}/{team.stages_scored?.length || 0}) con penalità di 10 crediti. {swapOut ? "Ora scegli il nuovo equipaggio dalla lista." : "Tocca uno slot per cederlo."}</div>}
            </div>
          )}
          <div className="grid sm:grid-cols-2 gap-2 max-h-80 overflow-y-auto pr-1">
            {list.map(e => { const on = sel.includes(e.id); return (
              <button key={e.id} onClick={() => info.locked ? swap(e) : toggle(e)} disabled={busy || (info.locked && (!swapOut || on))} data-testid={`fanta-entry-${e.number}`}
                className={`text-left border rounded-lg px-3 py-2 text-sm flex items-center justify-between gap-2 ${on ? "border-[#FF9F0A] bg-[#FF9F0A]/10" : "border-white/10 hover:border-[#FF1E27]/50"} disabled:opacity-60`}>
                <div className="min-w-0"><span className="font-mono-rl text-[#FF1E27] mr-2">#{e.number}</span>{e.driver}<div className="text-[10px] text-slate-500 truncate">{e.car}{e.class_name ? ` · ${e.class_name}` : ""}</div></div>
                <span className="font-mono-rl text-xs text-[#FF9F0A] shrink-0">{e.cost} cr</span>
              </button>); })}
          </div>
        </div>
        <div className="rl-card p-5" data-testid="fanta-leaderboard">
          <h3 className="font-display font-bold text-lg flex items-center gap-2 mb-3"><Trophy className="w-5 h-5 text-[#FF9F0A]" /> Classifica squadre</h3>
          {lb.length === 0 && <div className="text-sm text-slate-500">Nessuna squadra ancora. Sii il primo!</div>}
          <div className="space-y-1">
            {lb.slice(0, 20).map(t => (
              <div key={t.id} className={`flex items-center justify-between text-sm px-3 py-2 rounded-lg border ${t.user_id === user?.id ? "border-[#FF9F0A]/50 bg-[#FF9F0A]/5" : "border-white/5"}`}>
                <div><span className="font-display font-black text-slate-500 mr-2">P{t.pos}</span>{t.name} <span className="text-[10px] text-slate-500">· {t.owner}</span></div>
                <span className="font-mono-rl font-bold">{t.points}</span>
              </div>))}
          </div>
        </div>
      </div>
    </div>
  );
}
